function setLedgerHotKeys(params) {

    //setLedgerHotKeys(
    //    {
    //        modalID: 'modalId',
    //        ledgerID: 'dtId',
    //        onEnter: function (dt,elFocused) { }
    //    }
    //);

    if (params.fulldirect == true) {
        $(document).on('keydown', function (e) {            

            let elFocused = $(e.currentTarget.activeElement);
            let elFocusedRow = elFocused.closest('tr');
            let dTable = $('#' + params.ledgerID);
            let dataTableID = elFocusedRow.closest('.k-datatable').attr('id');

            let datafield = elFocused.attr('data-field');
            let indexField = elFocused.index();

            let prevrow = elFocusedRow.prev();
            let prevtel = prevrow.find('td:eq(' + indexField + ')');

            let nextrow = elFocusedRow.next();
            let nextel = nextrow.find('td:eq(' + indexField + ')');

            if (params.modalID === '' || params.modalID === undefined || params.modalID === null) {
                if (!$('.modal').hasClass('show')) {
                    if (e.ctrlKey) {
                        try {
                            switch (e.which) {
                                //CTRL+G
                                case 71:
                                    e.preventDefault();
                                    if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                        e.preventDefault();
                                        let elRow = $('#' + params.ledgerID + ' table tbody tr:first td:first');
                                        elRow.focus();

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onCtrlG === "function") {
                                            params.onCtrlG(dTable, _newFocus);
                                        }
                                    }
                                    break;
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }

                    try {
                        switch (e.which) {
                            //ENTER
                            case 13:
                                if (dataTableID == params.ledgerID) {
                                    if (elFocused.hasClass('k-datatable__cell')) {
                                        e.preventDefault();
                                        e.stopImmediatePropagation();

                                        if (elFocused.find('a:first').length != 0) {
                                            elFocused.find('a:first').click();
                                        } else {
                                            elFocused.find('button:first').click();
                                            elFocused.find('input[type="checkbox"]').click();
                                        }
                                    }
                                } else {
                                    e.preventDefault();
                                    e.stopImmediatePropagation();

                                    if (elFocused.find('a:first').length != 0) {
                                        elFocused.find('a:first').click();
                                    } else {
                                        elFocused.find('button:first').click();
                                        elFocused.find('input[type="checkbox"]').click();
                                    }
                                }
                                
                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.click();
                                }
                                break;
                            //UP
                            case 38:
                                if (dataTableID == params.ledgerID) {
                                    e.stopImmediatePropagation();
                                    e.preventDefault();

                                    if (elFocused.hasClass('k-datatable__cell')) {

                                        if (prevrow.length !== 0 && prevrow.hasClass('k-datatable__row')) {
                                            elFocusedRow.removeClass('row-focused');
                                            prevtel.focus();
                                        } else {
                                            if (prevrow.hasClass('k-datatable__row-subtable')) {
                                                elFocusedRow.removeClass('row-focused');
                                                prevrow.prev().find('td:eq(' + indexField + ')').focus();
                                            }
                                        }
                                    } else {
                                        if (prevrow.length !== 0 && prevrow.is('tr')) {
                                            elFocusedRow.removeClass('row-focused');
                                            prevtel.focus();
                                        }
                                    }
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    let elPrev = elFocused.prev();

                                    if (elPrev.hasClass('dropdown-divider')) {
                                        elPrev.prev().trigger('focus');
                                    } else {
                                        elFocused.prev().trigger('focus');
                                    }
                                }
                                break;
                            //DOWN
                            case 40:
                                if (dataTableID == params.ledgerID) {
                                    e.stopImmediatePropagation();
                                    e.preventDefault();

                                    if (elFocused.hasClass('k-datatable__cell')) {

                                        if (nextrow.length !== 0 && nextrow.hasClass('k-datatable__row')) {
                                            elFocusedRow.removeClass('row-focused');
                                            nextel.focus();
                                        } else {
                                            if (nextrow.hasClass('k-datatable__row-subtable')) {
                                                elFocusedRow.removeClass('row-focused');
                                                nextrow.next().find('td:eq(' + indexField + ')').focus();
                                            }
                                        }
                                    } else {
                                        if (nextrow.length !== 0 && nextrow.is('tr')) {
                                            elFocusedRow.removeClass('row-focused');
                                            nextel.focus();
                                        }
                                    }
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    let elNext = elFocused.next();

                                    if (elNext.hasClass('dropdown-divider')) {
                                        elNext.next().focus();
                                    } else {
                                        elFocused.next().focus();
                                    }

                                }
                                break;
                            //LEFT
                            case 37:
                                if (dataTableID == params.ledgerID) {
                                    e.stopImmediatePropagation();
                                    e.preventDefault();

                                    if (elFocused.hasClass('k-datatable__cell')) {
                                        // If KDatatable has locked columns
                                        if (elFocused.prev().length === 0 & elFocused.parents(':eq(1)').hasClass('k-datatable__lock')) {
                                            elFocused.parents(':eq(1)').prev('div.k-datatable__lock').find(`tr:nth-child(${elFocused.parent().index() + 1}) td:last-child`).focus();
                                        } else {
                                            elFocused.prev().focus();
                                        }
                                    } else {
                                        elFocused.prev().focus();
                                    }
                                }

                                break;
                            //RIGHT
                            case 39:
                                if (dataTableID == params.ledgerID) {
                                    e.stopImmediatePropagation();
                                    e.preventDefault();

                                    if (elFocused.hasClass('k-datatable__cell')) {
                                        // If KDatatable has locked columns
                                        if (elFocused.is('td') && elFocused.next().length === 0 & elFocused.parents(':eq(1)').hasClass('k-datatable__lock')) {
                                            elFocused.parents(':eq(1)').next('div.k-datatable__lock').find(`tr:nth-child(${elFocused.parent().index() + 1}) td:first-child`).focus();
                                        } else {
                                            elFocused.next().focus();
                                        }
                                    } else {
                                        elFocused.next().focus();
                                    }
                                }
                                break;
                        }
                        
                    } catch (e) {
                        console.log(e);
                    }

                }
            }
            else {
                let elModal = $('#' + params.modalID.toString());
                var openmodal = openmodals[openmodals.length - 1];
                if (elModal.hasClass('show') && $('#' + openmodal).is(':visible') && params.modalID.toString() === openmodal) {
                    if (e.ctrlKey) {
                        try {
                            switch (e.which) {
                                //CTRL+G
                                case 71:
                                    e.preventDefault();
                                    if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                        e.preventDefault();
                                        let elRow = $('#' + params.ledgerID + ' table tbody tr:first td:first');
                                        elRow.focus();

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onCtrlG === "function") {
                                            params.onCtrlG(dTable, _newFocus);
                                        }
                                    }
                                    break;
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }

                    try {
                        switch (e.which) {
                            //ENTER
                            case 13:
                                //if (dataTableID == params.ledgerID) {
                                    
                                //}

                                if (elFocused.hasClass('k-datatable__cell')) {
                                    e.preventDefault();

                                    if (elFocused.find('a:first').length != 0) {
                                        elFocused.find('a:first').click();
                                    } else {
                                        elFocused.find('button:first').click();
                                        elFocused.find('input[type="checkbox"]').click();
                                    }
                                } else {
                                    e.preventDefault();

                                    if (elFocused.find('a:first').length != 0) {
                                        elFocused.find('a:first').click();
                                    } else {
                                        elFocused.find('button:first').click();
                                        elFocused.find('input[type="checkbox"]').click();
                                    }
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.click();
                                }
                                break;
                            //UP
                            case 38:
                                //if (dataTableID == params.ledgerID) {
                                    
                                //}

                                e.preventDefault();

                                if (elFocused.hasClass('k-datatable__cell')) {

                                    if (prevrow.length !== 0 && prevrow.hasClass('k-datatable__row')) {
                                        elFocusedRow.removeClass('row-focused');
                                        prevtel.focus();
                                    } else {
                                        if (prevrow.hasClass('k-datatable__row-subtable')) {
                                            elFocusedRow.removeClass('row-focused');
                                            prevrow.prev().find('[data-field="' + datafield + '"]').focus();
                                        }
                                    }
                                } else {
                                    if (prevrow.length !== 0 && prevrow.is('tr')) {
                                        elFocusedRow.removeClass('row-focused');
                                        prevtel.focus();
                                    }
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.prev().focus();
                                    elFocused.parent().prev().children().focus();
                                }
                                break;
                            //DOWN
                            case 40:
                                //if (dataTableID == params.ledgerID) {
                                    
                                //}

                                e.preventDefault();

                                if (elFocused.hasClass('k-datatable__cell')) {

                                    if (nextrow.length !== 0 && nextrow.hasClass('k-datatable__row')) {
                                        elFocusedRow.removeClass('row-focused');
                                        nextel.focus();
                                    } else {
                                        if (nextrow.hasClass('k-datatable__row-subtable')) {
                                            elFocusedRow.removeClass('row-focused');
                                            nextrow.next().find('[data-field="' + datafield + '"]').focus();
                                        }
                                    }
                                } else {
                                    if (nextrow.length !== 0 && nextrow.is('tr')) {
                                        elFocusedRow.removeClass('row-focused');
                                        nextel.focus();
                                    }
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.next().focus();
                                    elFocused.parent().next().children().focus();
                                }
                                break;
                            //LEFT
                            case 37:
                                //if (dataTableID == params.ledgerID) {
                                    
                                //}

                                e.preventDefault();

                                if (elFocused.hasClass('k-datatable__cell')) {
                                    // If KDatatable has locked columns
                                    if (elFocused.prev().length === 0 & elFocused.parents(':eq(1)').hasClass('k-datatable__lock')) {
                                        elFocused.parents(':eq(1)').prev('div.k-datatable__lock').find(`tr:nth-child(${elFocused.parent().index() + 1}) td:last-child`).focus();
                                    } else {
                                        elFocused.prev().focus();
                                    }
                                } else {
                                    elFocused.prev().focus();
                                }

                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.parent().parent().prev().focus();
                                }
                                break;
                            //RIGHT
                            case 39:
                                //if (dataTableID == params.ledgerID) {
                                    
                                //}

                                e.preventDefault();

                                if (elFocused.hasClass('k-datatable__cell')) {
                                    // If KDatatable has locked columns
                                    if (elFocused.is('td') && elFocused.next().length === 0 & elFocused.parents(':eq(1)').hasClass('k-datatable__lock')) {
                                        elFocused.parents(':eq(1)').next('div.k-datatable__lock').find(`tr:nth-child(${elFocused.parent().index() + 1}) td:first-child`).focus();
                                    } else {
                                        elFocused.next().focus();
                                    }
                                } else {
                                    elFocused.next().focus();
                                }
                                

                                if (elFocused.hasClass('dropdown-item')) {
                                    elFocused.next().children().eq(0).children().focus();
                                }
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        });
    } else {

        $(document).on('keydown', function (e) {
            let elFocused = $(e.currentTarget.activeElement);
            let dTable = $('#' + params.ledgerID);
            if (params.modalID === '' || params.modalID === undefined || params.modalID === null) {
                if (!$('.modal').hasClass('show')) {
                    if (e.ctrlKey) {
                        try {
                            switch (e.which) {
                                //CTRL+G
                                case 71:
                                    e.preventDefault();
                                    if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                        e.preventDefault();
                                        let elRow = $('#' + params.ledgerID + ' table tbody tr:first');
                                        elRow.focus();

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onCtrlG === "function") {
                                            params.onCtrlG(dTable, _newFocus);
                                        }
                                    }
                                    break;
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }

                    try {
                        switch (e.which) {
                            //ENTER
                            case 13:
                                e.preventDefault();

                                if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                    if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                        params.onEnter(dTable, elFocused);
                                    }
                                }
                                break;
                            //UP
                            case 38:
                                e.preventDefault();
                                if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                    if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                        if (elFocused.prev().hasClass('k-datatable__row-subtable')) {
                                            elFocused.prevAll().eq(1).focus();
                                        } else {
                                            elFocused.prev().focus();
                                        }

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onUp == "function") {
                                            params.onUp(dTable, _newFocus);
                                        }
                                    }
                                }
                                break;
                            //DOWN
                            case 40:
                                e.preventDefault();
                                if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                    if (elFocused.next().hasClass('k-datatable__row-subtable')) {
                                        elFocused.next().next().focus();
                                    } else {
                                        elFocused.next().focus();
                                    }

                                    let _newFocus = $(e.currentTarget.activeElement);

                                    if (typeof params.onDown == "function") {
                                        params.onDown(dTable, _newFocus);
                                    }
                                }
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                }
            }
            else {
                let elModal = $('#' + params.modalID.toString());
                var openmodal = openmodals[openmodals.length - 1];
                if (elModal.hasClass('show') && $('#' + openmodal).is(':visible')) {
                    try {
                        if (e.ctrlKey) {
                            switch (e.which) {
                                //CTRL+G
                                case 71:
                                    e.preventDefault();
                                    if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                        e.preventDefault();
                                        let elRow = $('#' + params.ledgerID + ' table tbody tr:first');
                                        elRow.focus();

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onCtrlG === "function") {
                                            params.onCtrlG(dTable, _newFocus);
                                        }
                                    }
                                    break;
                            }
                        }

                        switch (e.which) {
                            //ENTER
                            case 13:
                                e.preventDefault();

                                if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                    if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                        params.onEnter(dTable, elFocused);
                                    }
                                }
                                break;
                            //UP
                            case 38:
                                e.preventDefault();
                                if (params.ledgerID !== null && params.ledgerID !== '' && params.ledgerID !== undefined) {
                                    if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                        if (elFocused.prev().hasClass('k-datatable__row-subtable')) {
                                            elFocused.prevAll().eq(1).focus();
                                        } else {
                                            elFocused.prev().focus();
                                        }

                                        let _newFocus = $(e.currentTarget.activeElement);

                                        if (typeof params.onUp == "function") {
                                            params.onUp(dTable, _newFocus);
                                        }
                                    }
                                }
                                break;
                            //DOWN
                            case 40:
                                e.preventDefault();
                                if (elFocused.is('#' + params.ledgerID + ' tr')) {
                                    if (elFocused.next().hasClass('k-datatable__row-subtable')) {
                                        elFocused.next().next().focus();
                                    } else {
                                        elFocused.next().focus();
                                    }

                                    let _newFocus = $(e.currentTarget.activeElement);

                                    if (typeof params.onDown == "function") {
                                        params.onDown(dTable, _newFocus);
                                    }
                                }
                                break;

                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        });
    }
}

function setQueryHotKeys(params) {
    //setDropdownMenuHotKeys(
    //    {
    //        onModalShown: false,
    //        modal: 'modalId',
    //        onEnter: function (searchContainer, elFocused) { }
    //        onUp: function (searchContainer, elFocused) { }
    //        onDown: function (searchContainer, elFocused) { }
    //        onF6: function (searchContainer, elFocused) { }
    //        onF9: function (searchContainer, elFocused) { }
    //    }
    //);

    $(document).on('keydown', function (e) {
        let elFocused = $(e.currentTarget.activeElement);
        let elContainer = $('#' + params.searchContainer);

        if (params.modalID === '' || params.modalID === undefined || params.modalID === null) {

            //if (!$('.modal').hasClass('show')) {
            if (!$('.modal').hasClass('show')) {
                if (e.ctrlKey) {
                    try {
                        switch (e.which) {
                            //CTRL+A
                            case 65:
                                if (typeof params.onCtrlA == "function" && !elFocused.is('input[type=text], input[type=number]')) {
                                    e.preventDefault();
                                    params.onCtrlA(elContainer, elFocused);
                                }  
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }

                if (!elFocused.hasClass('k-datatable__row')) {
                    try {
                        switch (e.which) {
                            //ENTER
                            case 13:
                                if (typeof params.onEnter == "function") {
                                    e.preventDefault();
                                    params.onEnter(elContainer, elFocused);
                                }
                                break;
                            //UP
                            case 38:
                                if (typeof params.onUp == "function") {
                                    e.preventDefault();
                                    params.onUp(elContainer, elFocused);
                                }
                                break;
                            //DOWN
                            case 40:
                                if (typeof params.onDown == "function") {
                                    e.preventDefault();
                                    params.onDown(elContainer, elFocused);
                                }
                                break;
                            //F6
                            case 117:
                                if (typeof params.onF6 == "function") {
                                    e.preventDefault();
                                    params.onF6(elContainer, elFocused);
                                }
                                break;
                            //F9
                            case 120:
                                if (typeof params.onF9 == "function") {
                                    e.preventDefault();
                                    params.onF9(elContainer, elFocused);
                                }
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    try {
                        switch (e.which) {
                            //F6
                            case 117:
                                if (typeof params.onF6 == "function") {
                                    e.preventDefault();
                                    params.onF6(elContainer, elFocused);
                                }
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        }
        else {
            let elModal = $('#' + params.modalID);
            var openmodal = openmodals[openmodals.length - 1];

            if (elModal.hasClass('show') && $('#' + openmodal).is(':visible') && params.modalID.toString() === openmodal) {
                //let elFocused = $(e.currentTarget.activeElement);
                //let elContainer = $('#' + params.searchContainer);

                try {
                    if (e.ctrlKey) {
                        switch (e.which) {
                            //CTRL+A
                            case 65:
                                e.preventDefault();
                                if (typeof params.onCtrlA == "function") {
                                    params.onCtrlA(elContainer, elFocused);
                                }
                                break;
                        }
                    }

                    switch (e.which) {
                        //ENTER
                        case 13:
                            e.preventDefault();
                            if (typeof params.onEnter == "function") {
                                params.onEnter(elContainer, elFocused);
                            }
                            break;
                        //UP
                        case 38:
                            e.preventDefault();
                            if (typeof params.onUp == "function") {
                                params.onUp(elContainer, elFocused);
                            }
                            break;
                        //DOWN
                        case 40:
                            e.preventDefault();
                            if (typeof params.onDown == "function") {
                                params.onDown(elContainer, elFocused);
                            }
                            break;
                        //F6
                        case 117:
                            e.preventDefault();
                            if (typeof params.onF6 == "function") {
                                params.onF6(elContainer, elFocused);
                            }
                            break;
                        //F7
                        case 118:
                            if (typeof params.onF7 == "function") {
                                e.preventDefault();
                                params.onF7(elContainer, elFocused);
                            }
                            break;
                        //F8
                        case 119:
                            if (typeof params.onF8 == "function") {
                                e.preventDefault();
                                params.onF8(elContainer, elFocused);
                            }
                            break;
                        //F9
                        case 120:
                            e.preventDefault();
                            if (typeof params.onF9 == "function") {
                                params.onF9(elContainer, elFocused);
                            }
                            break;
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }

    });
}

function SetFormIndexHotKey(params) {

    //SetFormIndexHotKey(
    //    {
    //        form: $('#form'),
    //        override: null,
    //    }
    //);

    //let listInput = params.form.find('input[type=text]:visible, select.bootstrap-select ~ button:not(:disabled):visible, .k-checkbox > span');
    //let listInput = params.form.find('input[type=text]:visible, select.bootstrap-select ~ button:visible, select.selectpicker ~ button:visible, .k-checkbox > span');
    let listInput = params.form.find('input[type=text]:visible, select ~ button, .k-checkbox > span');

    listInput.each((i, el) => {
        $(el).addClass('mas-record').attr('tabindex', 0).attr('data-mas-index', i);
    });

    params.form.on('keydown', '.mas-record', e => {
        if (e.which == 13) {
            e.preventDefault();

            if (params.override == undefined || params.override == null) {
                console.log(e);
                let i = parseInt($(e.target).attr('data-mas-index'));

                //Avoid Quick-Search text input
                if ($(listInput[i]).hasClass('.quick-search')) { return; }

                if (i + 1 > listInput.length) { $(listInput[0]).focus(); }
                else { $(listInput[i + 1]).focus(); }
            }
            else {
                params.override(listInput, listInput[i],nextInput[i+1]);
            }
            
        }
    });
}

function SetFormHotkey(params) {
    //SetFormHotkey({
    //    modal: $('#modal'),
    //    firstinput: modal.find('#txt'),
    //    onF8: 
    //    savebutton:
    //    onF7:
    //    savecontinuebutton:
    //    onEnter: {} //object
    //});

    let listFormInputs = params.modal.find('input:not([type=hidden]), textarea, select.bootstrap-select ~ button');
    let prev_index = 0;
    listFormInputs.each((i, el) => {
        $(el).addClass('mas-record').attr('tabindex', 0).attr('data-mas-index', i);

        if ($(el).attr('required')) {
            $(el).parent().addClass('mas-required');
        }

    });
   

    $(document).on('keydown', function (e) {
        if (params.modal !== undefined && params.modal !== null) {

            var openmodal = openmodals[openmodals.length - 1];
            if (
                params.modal.hasClass('show')
                && $(params.modal).attr('id') == openmodal
            )
            {

                if (e.altKey) {
                    switch (e.which) {
                        case 73:
                            if (params.hasOwnProperty("altKey")) {
                                if (params.altKey.hasOwnProperty("onI")) {
                                    if (params.altKey.onI !== undefined && params.altKey.onI !== null) {
                                        e.preventDefault();
                                        params.altKey.onI(params.modal);
                                    }
                                }
                            }

                            break;
                    }
                } else if (e.ctrlKey) {
                    switch (e.which) {
                        case 65: 
                            if (typeof params.onCtrlA == "function" && !$(document.activeElement).is('input[type=text]')) {
                                e.preventDefault();
                                params.onCtrlA();
                            }
                            break; 
                    }
                }
                else {
                    switch (e.which) {
                        case 27:
                            e.preventDefault();
                            if (params.onEsc !== undefined && params.onEsc !== null) {
                                params.onEsc(params.modal);
                            }
                            break;
                        case 117:
                            e.preventDefault();
                            if (params.onF6 !== undefined && params.onF6 !== null) {
                                params.onF6(params.modal);
                            }
                            break;
                        case 119:
                            e.preventDefault();
                            if (params.onF8 !== undefined && params.onF8 !== null) {
                                params.onF8(params.modal);
                            }
                            else {
                                if (params.savebutton !== undefined && params.savebutton !== null) {
                                    params.savebutton.click();
                                }
                            }
                            break;
                        case 118:
                            e.preventDefault();
                            if (params.onF7 !== undefined && params.onF7 !== null) {
                                params.onF7(params.modal);
                            } else {
                                if (params.savecontinuebutton !== undefined && params.savecontinuebutton !== null) {
                                    params.savecontinuebutton.click();
                                }
                            }
                            break;
                        case 122:
                            e.preventDefault();
                            if (params.onF11 !== undefined && params.onF11 !== null) {
                                params.onF11(params.modal);
                            } 
                            break;
                        case 123:
                            e.preventDefault();
                            if (params.onF12 !== undefined && params.onF12 !== null) {
                                params.onF12(params.modal);
                            } 
                            break;
                        default:
                            //e.preventDefault();
                            //let elementFocused = $(e.currentTarget.activeElement);
                            //elementFocused.next().focus();
                            break;
                    }

                }

                //if (e.which == 13) {
                //    if (params.onEnter !== undefined && params.onEnter !== null) {
                //        params.onEnter(modal);
                //    } else {
                //        var elementFocused = $(e.currentTarget.activeElement);
                //        elementFocused.next().focus();
                //    }
                //}
            }
        }
    });

    params.modal.on('keydown', '.mas-record', e => {
        let i = parseInt($(e.target).attr('data-mas-index')),
            id = $(e.target).attr('id'),
            currentInput = $(listFormInputs[i]),
            nextInput = $(listFormInputs[i + 1]);

        if (e.which == 13) {
            //Avoid Quick-Search text input, and textarea
            if (currentInput.is('.quick-search, textarea, .tt-input')) { return; }

            if (typeof params.onEnter == "object") {
                if (params.onEnter.hasOwnProperty(id) && typeof params.onEnter[id] == "function") {
                    params.onEnter[id](e, listFormInputs, currentInput, nextInput);
                } else {
                    proceedToNextElement(e, i, nextInput);
                }
            } else {

                if (currentInput.is('input:checkbox')) {
                    currentInput.trigger('click');
                    proceedToNextElement(e, i, nextInput);
                } else {
                    proceedToNextElement(e, i, nextInput);
                }
            }
        } else {
            if (e.which == 9 && e.shiftKey == false) {
                prev_index = i;
                proceedToNextElement(e, i, nextInput);
            }
        }

    });

    //params.modal.on('keyup', '.mas-record', e => {
    //    let i = prev_index,
    //        lastMasRecordInput = $(listFormInputs[i]),
    //        nextInput = $(listFormInputs[i + 1]);

    //    if (e.which == 9 && !e.shiftKey) {

    //        if (!$(document.activeElement).is(':visible:not(.tt-hint):not(.search-input-custom):not(.quick-search)')) {
    //            proceedToNextElement(e, i, nextInput);
    //        }
    //    }
    //});

    params.modal.on('focus', '.mas-record', e => {
        if ($(e.currentTarget).is('input[type="text"], input[type="number"], textarea')) {
            $(e.currentTarget).select();
        }
    });

    //Initial Modal Shown
    firstInputEvent();

    params.modal.on('shown.bs.modal', function () {
        firstInputEvent();
    });


    function firstInputEvent() {
        if (params.firstinput !== undefined && typeof params.firstinput != "function") {
            params.firstinput.focus();
        }
        else if (typeof params.firstinput == "function") {
            params.firstinput(); // FOR OVERRIDE
        }
        else {
            params.modal.find('form input:not([readonly]):enabled:visible:first').focus();
        }
    }

    function proceedToNextElement(e, i, nextInput) {
        if (i + 1 > listFormInputs.length) {
            //e.preventDefault();
            //$(listFormInputs[0]).focus();
        }
        else {
            getNextVisibleInput(e, i, nextInput);
            //$(listFormInputs[i + 1]).focus();
        }
    }

    function getNextVisibleInput(e,i, nextInput) {
        if (nextInput.is(":visible") && nextInput.is(":not(.tt-hint):not(:disabled):not([readonly])")) {
            e.preventDefault();

            if (nextInput.hasClass('pointer-events-none')) {
                return;
            } else {
                nextInput.focus();
            }

            return;
        } else {
            i++;
            nextInput = $(listFormInputs[i + 1]);
            proceedToNextElement(e, i, nextInput);
        }
    }

   
}

function SetModalHotkeys(params) {

}